const certNweaConfig = {
  name: 'cert',
  rootUrl: 'https://login.cert.mapnwea.org/ui/',
  loginUrl: 'https://login.cert.mapnwea.org/ui/login/',
  loggedInUrl: 'https://auth.perf.nwea.org/adult/verifyHcpAuthorizationCode',
  loggedOutUrl: 'https://platform.cert.heinemann.com/ui/login/logged-out/',
  helpUrl: 'https://connection.nwea.org/s/support?language=en_US',
  privacyPolicyUrl: 'https://www.nwea.org/policy/privacy-and-terms/',
  termsAndConditionsUrl:
    'https://www.nwea.org/policy/nwea-platform-terms-of-use/',
  forgotPasswordUrlPath: '/ui/login/forgot-password/',
  requestSigninDetailsUrlPath: '/ui/login/request-signin-details/',
  restIdsGridApi: 'https://api.cert.hmhco.com/ids-grid-api',
  hcpIdentityApiGateway: 'https://hapi.cert.hmhco.com/hcp-identity-api-gateway',
  edsAuthorizationCode:
    'https://hapi.cert.hmhco.com/edcore/eds-login/login/authorization-code/callback',
  susAuth: 'https://cert.hmhco.com/api/authorization',
  authorizationApi: 'https://cert.hmhco.com/api/authorization',
  edsInitUrl:
    'https://hapi.cert.hmhco.com/edcore/eds-login/login/initializeUri',
  ampLogin: 'https://login.cert.mapnwea.org/ui/login',
  nweaIssuer: 'https://hapi.cert.hmhco.com/edcore/eds-login',
  nweaStartUrl: 'https://perf01-admin.mapnwea.org',
};

module.exports = certNweaConfig;
